import { cn } from '../lib/cn';

interface LogoProps {
  size?: number;
  className?: string;
  variant?: 'icon' | 'full';
}

export function DoorlyLogo({ size = 32, className, variant = 'icon' }: LogoProps) {
  if (variant === 'full') {
    return (
      <img
        src="/logo-full.svg"
        alt="Doorly"
        className={cn(className)}
        style={{ height: size }}
      />
    );
  }
  return (
    <img
      src="/logo-icon.svg"
      alt="Doorly"
      className={cn(className)}
      style={{ width: size, height: size }}
    />
  );
}
